<template>
  <client-only>
    <v-snackbar
      :variant="mainStore.snackbar.variant"
      :color="mainStore.snackbar.color"
      location="top right"
      v-model="mainStore.snackbar.display"
      :timeout="6000"
      :vertical="!!mainStore.snackbar.link"
    >
      <div>{{ mainStore.snackbar.text }}</div>

      <template v-slot:actions>
        <v-btn v-if="mainStore.snackbar.link" variant="flat" :to="mainStore.snackbar.link" class="mt-3 mb-2" color="primary">Ver</v-btn>
        <v-spacer />
        <v-btn variant="tonal" @click.native="mainStore.snackbar.display = false" :class="[!!mainStore.snackbar.link ? 'mt-3 mb-2' : '']">Fechar</v-btn>
      </template>
    </v-snackbar>
  </client-only>
</template>

<script setup lang="ts">
defineOptions({
  name: "SnackbarAlert",
});

const mainStore = useMainStore();
</script>
